import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "divider" }, " | ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "divider" }, " | ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "This website is currently in development phase.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createTextVNode(" © 2024 MidGrnd. All rights reserved. "),
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode("Privacy Policy")
        ]),
        _: 1
      }),
      _hoisted_2,
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode("Terms of Use")
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode("Contact Us")
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ]))
}